module.exports = __webpack_public_path__ + "img/items-grid-04.de3514b5.png";